import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { SpaceType } from 'constants/index';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);
var Container = styled.div.withConfig({
  displayName: "PrivateSpaceCard__Container",
  componentId: "sc-o5qnz0-0"
})([".mySwiper{--swiper-theme-color:white !important;}img{width:100%;vertical-align:top;}"]);

var PrivateSpaceCard = function PrivateSpaceCard(_ref) {
  var space = _ref.space;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs("li", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "photo-w",
        children: /*#__PURE__*/_jsx(Swiper, {
          navigation: true,
          spaceBetween: 30,
          pagination: true,
          className: "mySwiper",
          children: space.service_images.map(function (image) {
            return /*#__PURE__*/_jsx(SwiperSlide, {
              children: /*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx("img", {
                  src: image.image,
                  alt: ""
                })
              })
            }, image.image);
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "info-w",
        children: [/*#__PURE__*/_jsxs("strong", {
          children: [/*#__PURE__*/_jsx("span", {
            children: SpaceType[space.private_space_type]
          }), Number(space.price).toLocaleString('ko-KR'), "\uC6D0 ~ / \uC6D4"]
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("p", {
            style: {
              whiteSpace: 'pre-line'
            },
            children: space.description
          })
        })]
      })]
    })
  });
};

export default PrivateSpaceCard;